
  <div class="container h-100">
    <div class="row" *ngIf="ocorrencias.length > 0">

    <div class="col-md-12 col-sm-12 pt-3  scroll-table">
        <div id='ocorrencias-total' >
          <div *ngFor="let ocorrencia of dadosOcorrencias" class="w-100 m-3">
            <div class="box-new d-flex justify-content-center" [ngClass]="ocorrencia.bgColor">            
              <img [src]='ocorrencia.img' class="me-3">            
              <div >
                <div class="titulo">{{ ocorrencia.descricao }}</div>
                <div class='dados'>{{ ocorrencia.qtdOcorrencia }}</div>
              </div>             
            </div>
          </div>     

        </div>
        <div id='card-tabela'>
          <table class="table">
            <thead>
                <tr >
                    <th class="pt-0 table-titulo" >Roteiro</th>
                    <th class="pt-0 table-titulo">Em Aberto</th>
                    <th class="pt-0 table-titulo">Em Avaliação</th>
                    <th class="pt-0 table-titulo">Finalizadas</th>
                </tr>
            </thead>
            <tbody *ngFor="let ocorrencia of ocorrencias">              
                <tr  (click)="abrirOcorrencias(ocorrencia)" class="hover-cursor">
                    <td>{{ ocorrencia.NumeroRoteiro }}</td>
                    <td>{{ ocorrencia.emAberto }}</td>
                    <td>{{ ocorrencia.emAnalise }}</td>
                    <td>{{ ocorrencia.finalizadas }}</td>
                </tr>             
            </tbody>
        </table>
        </div>
      </div>  
  </div>

  <div *ngIf="ocorrencias.length == 0" class="nao-relatada">
      <p>Nenhuma ocorrência relatada.</p>
  </div>
</div>